if ('IntersectionObserver' in window) {
  observer();
} else {
  import(/* webpackChunkName: "interaction-observer" */ 'intersection-observer').then(() => {
    observer();
  });
}

function observer() {
  let observer;

  const options = {
    root: null,
    rootMargin: "0px",
  };

  const footer = document.querySelector(".footer");

  if(!footer) {
    return;
  }
  observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(footer);
}


function handleIntersect(entries, observer) {
  entries.forEach(function(entry) {
    const cc = document.querySelector('.cc-window');

    // Cookie Consent is not loaded yet.
    if(!cc) {
      return;
    }

    if(entry.isIntersecting) {
      cc.classList.add('is-over-footer');
    } else {
      cc.classList.remove('is-over-footer')
    }
  })
}
